import {Injectable} from "@angular/core";
import {MIHttpClientService} from "../shared/mi-http-client.service";
import {Observable, of} from "rxjs";
import PackageInfo from "../../../package.json";
import {IWhatsNewContents} from "./whats-new.model";
import {tap} from "rxjs/operators";
import {NotificationService} from "../shared/notification.service";

@Injectable({
  providedIn: 'root',
})
export class WhatsNewContentService {



  constructor(
    private miClient: MIHttpClientService,
    private notificationService: NotificationService,

    ) {
  }


  clearCachedContent() {
    localStorage.removeItem('latestWhatsNewContent');
  }

  reloadLatestContent(): Observable<IWhatsNewContents> {
    this.clearCachedContent();

    const VERSION: string = PackageInfo.version;
    const currentLang = localStorage.getItem('language') || 'en';
    return this.miClient.get(`whatsNewContent?application=Portal&maxVersion=${VERSION}&lang=${currentLang}`).pipe(tap ( (contents: IWhatsNewContents) => {
      localStorage.setItem('latestWhatsNewContent', JSON.stringify(contents));
    }));
  }

  getLatestContent(): Observable<IWhatsNewContents> {
    const cachedContent = localStorage.getItem('latestWhatsNewContent');
    if (cachedContent) {
      return of(<IWhatsNewContents>JSON.parse(cachedContent));
    }

    const VERSION: string = PackageInfo.version;
    const currentLang = localStorage.getItem('language') || 'en';
    return this.miClient.get(`whatsNewContent?application=Portal&maxVersion=${VERSION}&lang=${currentLang}`).pipe(
      tap(      (contents: IWhatsNewContents) => {
      localStorage.setItem('latestWhatsNewContent', JSON.stringify(contents));
      }));
  }

  recordContentSeen(version: string) {
    const currentLang = localStorage.getItem('language') || 'en';
    this.miClient.post('whatsNewContent/recordContentSeen?application=Portal&version=' + encodeURIComponent(version) + '&lang=' + encodeURIComponent(currentLang)).subscribe(() => {
      this.reloadLatestContent();
    });
  }

}
